import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {Loader} from "../../../components/admin/Loader";
import {DocumentForm} from "../../../components/admin/document/DocumentForm";
import {documentResultType} from "../../../types/Api/DocumentResultType";
import {document} from "../../../models/document";
import {documentHydrator} from "../../../models/hydrator/documentHydrator";
import {BoxTitle} from "../../../components/admin/BoxTitle";

export const Edit = () => {
  const uuid: undefined|string = useParams().uuid;

  const [document, setDocument] = useState(undefined as undefined | document);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/document/${uuid}`) as Promise<documentResultType>;

      setLoading(true);

      result
        .then((r) => {
          setDocument(documentHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {!loading && (document || !uuid) && (
        <>
          <BoxTitle title={uuid ? 'Modifier un document' : 'Ajouter un document'}/>
          <DocumentForm document={document} />
        </>
      )}
    </>
  );
}
